import styled from 'styled-components';
import { width } from 'styled-system';
import { strictSpace } from '../../../utils';
import { animated } from '@react-spring/web';
import { ButtonSize } from '../../Buttons';
var StyledContainer = styled(animated.div).withConfig({
  displayName: "styles__StyledContainer",
  componentId: "sc-xnytoh-0"
})(["", " position:relative;display:", ";width:", ";", " will-change:transform;border-radius:", ";.content-container{border-radius:", ";position:absolute;top:0;left:0;width:100%;height:100%;overflow:hidden;-webkit-mask-image:-webkit-radial-gradient(white,black);pointer-events:none;}.ripple{content:'';position:absolute;top:50%;left:0%;height:", "px;width:", "px;background-color:", ";border-radius:100px;}.ersatz-shadow{border-radius:", ";box-shadow:", ";position:absolute;pointer-events:none;top:0;left:0;bottom:0;right:0;}"], strictSpace, function (_ref) {
  var size = _ref.size;
  return !size || size === ButtonSize.Large ? 'block' : 'inline-block';
}, function (_ref2) {
  var size = _ref2.size;
  return !size || size === ButtonSize.Large ? '100%' : 'auto';
}, width, function (props) {
  return props.$borderRadius;
}, function (props) {
  return props.$borderRadius;
}, function (props) {
  return props.$rippleSize;
}, function (props) {
  return props.$rippleSize;
}, function (props) {
  return props.theme.colors[props.$rippleColor] || props.$rippleColor;
}, function (props) {
  return props.$borderRadius;
}, function (props) {
  return props.$shadowType;
});
export default StyledContainer;